"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactSvg = require("react-svg");

var _home = _interopRequireDefault(require("pubweb-smokey/dist/images/svg/iconography-16x16/home.svg"));

var _mountains = _interopRequireDefault(require("pubweb-smokey/dist/images/svg/iconography-16x16/mountains.svg"));

var _paintbrush = _interopRequireDefault(require("pubweb-smokey/dist/images/svg/iconography-16x16/paintbrush.svg"));

var _v = _interopRequireDefault(require("./images/404_v2.svg"));

var _SectionLink = _interopRequireDefault(require("../Shared/SectionLink/SectionLink"));

var _NotFound = require("./NotFound.styled");

var NotFoundContent = function NotFoundContent(_ref) {
  var _ref$internalLink = _ref.internalLink,
      internalLink = _ref$internalLink === void 0 ? true : _ref$internalLink,
      _ref$addSiteUrl = _ref.addSiteUrl,
      addSiteUrl = _ref$addSiteUrl === void 0 ? false : _ref$addSiteUrl,
      _ref$siteUrlOverride = _ref.siteUrlOverride,
      siteUrlOverride = _ref$siteUrlOverride === void 0 ? "" : _ref$siteUrlOverride;

  /* eslint-disable react/no-unescaped-entities */
  return /*#__PURE__*/_react.default.createElement(_NotFound.NotFoundStyles, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "not-found-container constrained-width"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "not-found-content"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "error label large"
  }, "404 error"), /*#__PURE__*/_react.default.createElement("h2", null, "Oops, nobody's home!"), /*#__PURE__*/_react.default.createElement("p", {
    className: "try-these"
  }, "Try these helpful links instead."), /*#__PURE__*/_react.default.createElement("div", {
    className: "link-container"
  }, /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    internalLink: internalLink,
    siteUrlOverride: siteUrlOverride,
    addSiteUrl: addSiteUrl,
    className: "label large",
    to: "/find-a-home/"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "link first-link find-a-home-link"
  }, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _home.default,
    className: "icon",
    alt: "Home"
  }), "find a home")), /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    className: "label large second-anchor",
    to: "/find-land/"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "link second-link find-land-link"
  }, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _mountains.default,
    className: "icon",
    alt: "Mountains"
  }), "find land")), /*#__PURE__*/_react.default.createElement(_SectionLink.default, {
    internalLink: internalLink,
    addSiteUrl: addSiteUrl,
    siteUrlOverride: siteUrlOverride,
    to: "/get-inspired/",
    className: "label large"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "link third-link get-inspired-link"
  }, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _paintbrush.default,
    className: "icon",
    alt: "Paintbruch"
  }), "get inspired")))), /*#__PURE__*/_react.default.createElement("div", {
    className: "not-found-illustration"
  }, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _v.default,
    className: "not-home-illustration",
    alt: "Not Home Ilustration"
  }))));
  /* eslint-enable react/no-unescaped-entities */
};

var _default = NotFoundContent;
exports.default = _default;